<app-workspace-master-detail [detailOpen]="detailOpen">
  <app-customers workspace-master></app-customers>
  <div workspace-detail class="workspace-page--full">
    <router-outlet (deactivate)="reviewClosed($event)"></router-outlet>
  </div>
</app-workspace-master-detail>
